import React from 'react';
import { Box, styled } from '@mui/material';
import { NavigationMenuItem } from '../../../models/NavigationMenuItem';
import useShopifyMenuSWR from '../../../hooks/shopify/useShopifyMenuSWR';
import { CollectionNavigationItem } from '../../navigation/CollectionNavigationItem';

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    // alignItems: 'center',
    alignItems: 'stretch',
    width: '100%',
    padding: '0 3.175%',
    backgroundColor: '#f4f4f4',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));

export const CollectionNavigation = () => {
    const { menuItems, isLoading, isError, forceRefresh } =
        useShopifyMenuSWR('main-menu');

    if (isLoading || isError) {
        return <></>;
    }

    return (
        <>
            <StyledBox>
                {menuItems.items.map((item: NavigationMenuItem) => (
                    <CollectionNavigationItem key={item.id} menuItem={item} />
                ))}
            </StyledBox>
        </>
    );
};
